import { API, handleApiError } from "./utils";

const path = "members";

export const fetchMembers = async () => {
  try {
    const res = await API.get(`/${path}/fetch-members`, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return { error: null, data: res.data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const createMember = async (organisationId, member) => {
  try {
    const res = await API.post(`/${path}/create`, {
      organisationId,
      member
    }, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return { error: null, data: res.data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const deleteMember = async (organisationId, memberId) => {
  try {
    const res = await API.post(`/${path}/delete`, {
      organisationId,
      memberId
    }, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return { error: null, data: res.data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const updateMemberName = async (organisationId, memberId, name) => {
  try {
    const res = await API.post(`/${path}/update-name`, {
      organisationId,
      memberId,
      name
    }, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return { error: null, data: res.data };
  } catch (error) {
    return handleApiError(error);
  }
};